import { useGetConsultantOpportunityStatsByUserQuery } from "@bonliva-crm/graphql";
import { StatsRow } from "./stats-row";
import { useLocale } from "@hooks";

type Props = {
  userId: string;
  userName: string;
  start: Date;
  end: Date;
};

export function UserStats(props: Props) {
  const { locale } = useLocale();

  const userStats = useGetConsultantOpportunityStatsByUserQuery({
    variables: {
      userId: props.userId,
      start: props.start,
      end: props.end
    },
    fetchPolicy: "network-only"
  });

  return (
    <StatsRow
      title={`${locale.personal} (${props.userName})`}
      loading={userStats.loading}
      data={userStats.data?.consultantOpportunityStatsByUser}
    />
  );
}
